import { onScopeDispose, watch, type Ref } from 'vue'

const EVENTS = ['pointerdown', 'keydown', 'wheel', 'touchstart'] as const
const CHANNEL = 'ifs.activity'

/**
 * Log out after `minutes` without user activity (spec §12: 15 minutes, to confirm with the bank).
 * Activity in any tab keeps every tab alive.
 */
export function useIdleLogout(active: Ref<boolean>, minutes: number, onIdle: () => void) {
  let timer: ReturnType<typeof setTimeout> | undefined
  let lastBroadcast = 0
  const channel = typeof BroadcastChannel !== 'undefined' ? new BroadcastChannel(CHANNEL) : null

  const arm = () => {
    clearTimeout(timer)
    timer = setTimeout(onIdle, minutes * 60_000)
  }

  const onActivity = () => {
    arm()
    const now = Date.now()
    if (now - lastBroadcast > 10_000) {
      lastBroadcast = now
      channel?.postMessage('active')
    }
  }

  const start = () => {
    EVENTS.forEach((e) => window.addEventListener(e, onActivity, { passive: true }))
    if (channel) channel.onmessage = arm
    arm()
  }
  const stop = () => {
    clearTimeout(timer)
    EVENTS.forEach((e) => window.removeEventListener(e, onActivity))
    if (channel) channel.onmessage = null
  }

  watch(active, (on) => (on ? start() : stop()), { immediate: true })
  onScopeDispose(() => {
    stop()
    channel?.close()
  })
}
